var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"li-item"},[_c('span'),_c('div',{staticClass:"text",style:(("margin-right:" + _vm.marginRight + "px"))},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("detail")],2)}
var staticRenderFns = []

export { render, staticRenderFns }